<template>

   <!-- Top -->
   <div id="top"></div>

   <!-- Main -->
  <div class="row supervisor-claims-frame">
    <div class="col s12 supervisor-claims-frame-col">

      <LoadingDiv v-if="!isReady" />

      <div class="compliance-review supervisor-claims-workbench" v-else>

        <div class="premium-queue-head">
          <div class="queue-title-block">
            <label class="active teal-text">Compliance Review</label>
            <h5>Claims Awaiting Compliance Action</h5>
            <p>{{ clusters.length }} {{ clusters.length === 1 ? "batch" : "batches" }} showing under {{ currentStateTitle }}.</p>
          </div>

          <div class="scheme-switch">
            <button
              v-for="tab in tabsState"
              :key="tab.id"
              type="button"
              :class="{ 'is-active': tab.id === currState }"
              @click="handleState(tab.id)"
            >
              {{ tab.title.toUpperCase() }}
            </button>
          </div>
        </div>
  
         <!-- loading -->      
          <div class="claims-loading-bar progress" v-if="isLoading">
                <div class="indeterminate"></div>
          </div>

        <div v-for="(cluster, index) in clusters" :key="cluster.id">
          <div class="claim-batch-row" :class="{ 'is-open': currCluster?.id == cluster.id }" v-if="currCluster?.id == cluster.id || !currCluster">
            <div class="row mb-zero">
              <div class="col s2 m1 hide-on-small-only">
                <p class="row-index">{{ numberBadge(index) }}</p>
              </div>
              <div class="col s12 m3">
                <h6 class="provider-cell">
                  <span v-if="cluster.compliance_flags_count > 0"><i class="tiny material-icons red-text" title="compliance issue">flag</i></span>
                  {{ capWords(cluster.provider.name) }}
                  <span
                    class="claim-context-badge"
                    :class="claimContext(cluster) ? `is-${claimContext(cluster).key}` : null"
                    v-if="claimContext(cluster)"
                  >
                    {{ claimContext(cluster).label }}
                  </span>
                  <br />
                  <span v-if="cluster.status === 'r' || cluster.status === 'v'"><small>({{ cluster.encounters_count }}
                      Claims)</small></span>
                </h6>
              </div>
              <div class="col s4 m2">
                <p>
                  <span class="chip red lighten-5 red-text" v-if="cluster.status === 'r' || cluster.status === 'v'">₦{{
                    new Intl.NumberFormat('en-NG', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(cluster.encounters_total_sent || '0.00') }}</span>
                </p>
              </div>
              <div class="col s4 m2">
                <p>
                  <span class="chip green lighten-5 green-text" v-if="cluster.status === 'r' || cluster.status === 'v'"><b>₦{{
                    new Intl.NumberFormat('en-NG', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(cluster.encounters_total_approved || '0.00') }}</b></span>
                </p>
              </div>
              <div class="col s4 m2">
                <p class="period-cell">
                  {{ toMonthYear(cluster.month_year) }}
                  <small><b>({{ cluster.scheme.name }})</b></small>
                </p>
              </div>
              <div class="col s6 m1">
                <p class="agent-cell" title="agent">
                  <em>{{ cluster?.slug }}</em>
                </p>
              </div>
              <div class="col s6 m1">
                <span v-if="
                  (cluster.status === 'r' || cluster.status === 'v') &&
                  !currCluster
                ">
                  <button type="button" class="row-action right" @click="handleView(cluster)" title="details">
                    <i class="material-icons">chevron_right</i>
                  </button>
                </span>
                <span class="right" v-else>
                  <button type="button" class="row-action is-close" @click="handleClear()" title="go back">
                    <i class="material-icons">keyboard_return</i>
                  </button>
                </span>
              </div>
            </div>
          </div>
        </div>

        <!-- Cluster details -->
        <ClaimDiv :clusterId="currCluster.id" @reset="handleReset" v-if="currCluster" />

        <!-- Pages -->
        <template v-else>
          <div class="empty-review-state" v-if="!clusters.length">
            <div class="empty-review-icon">
              <i class="material-icons">policy</i>
            </div>
            <h6>{{ currState === 0 ? "No compliance claims" : `No compliance claims for ${currentStateTitle}` }}</h6>
            <p v-if="currState === 0">There are no claim batches waiting for compliance action.</p>
            <p v-else>This scheme has no claim batches waiting for compliance action.</p>
          </div>

          <PaginationDiv :payLoad="allPages" @newPage="handlePage" v-else />
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import { computed, onMounted, ref, watch } from "vue";
import { useStore } from "vuex";
import getItems from "@/composables/getItems";
import ClaimDiv from "@/components/compliance/ComplianceSingleClaimComponent.vue";
// import {
//   grossTotalSentFx,
//   grossTotalApprovedFx,
// } from "@/composables/calFunction/cal";
import {
  toMonthYearFx,
  capWordsFx,
} from "@/composables/fxLibrary/coreFx.js";
import { claimBatchContext } from "@/composables/claimBatchContext";
import PaginationDiv from "@/components/pager/PaginationDiv.vue";
import LoadingDiv from "@/components/LoadingDiv.vue";

export default {
  name: "ComplianceClaimsComponent",
  components: { LoadingDiv, PaginationDiv, ClaimDiv },
  props: ["resetKey"],
  setup(props) {
    const response = ref(null);
    const isReady = ref(false);
    const isLoading = ref(true);
    const error = ref(null);
    const currCluster = ref(false);
    const currUrl = ref(null);
    const currHook = ref(null);
    const currServerDate = ref(null);
    const tabsState = ref([]);
    const currState = ref(null);

    // store
    const store = useStore();

    // start
    onMounted(() => {
      // load tab
      tabsState.value.push({ id: 0, title: "All" });

      // load tab
      store.state.user.schemes.forEach((x) => {
        tabsState.value.push({ id: x.id, title: capWords(x.name) });
      })

      // set default (all)
      currState.value = 0;
    });


    //from functions
    const capWords = (val) => {
      return capWordsFx(val);
    };

    const claimContext = (cluster) => {
      return claimBatchContext(cluster);
    };

    // numbering
    const numberBadge = (num) => {
      return (
        (allPages.value.current_page - 1) * allPages.value.per_page + num + 1
      );
    };

    // total calculations (gross sent)
    // const grossTotalSent = (encounters) => {
    //   return grossTotalSentFx(encounters);
    // };

    // total calculations (gross approved)
    // const grossTotalApproved = (encounters, db) => {
    //   return grossTotalApprovedFx(encounters, db);
    // };

    // convert to Month & Year
    const toMonthYear = (val) => {
      return toMonthYearFx(val);
    };

    // payment status
    const checkPaid = (payment, repayment) => {
      let val = false;

      if (payment) {
        if (payment.stage == "c") {
          val = true;
        }
      }

      if (repayment) {
        if (repayment.stage == "c") {
          val = true;
        }
      }

      return val;
    };

    // get function
    const getItemsFromApi = (table) => {
      (async () => {
        const { res, err } = await getItems(table);

        if (res.value) {
          response.value = res.value.data;
        } else {
          error.value = err.value;
        }

        // page is ready, loading is complete
        isReady.value = true;
        isLoading.value = false;
      })();
    };

    // starter
    onMounted(() => {
      // get started
      getPendingClaims(0, true);
    });

    // get fresh load
    const getPendingClaims = (val, fullLoad = false) => {
      if (fullLoad || !response.value) {
        isReady.value = false;
      } else {
        isLoading.value = true;
      }
      // set current Url
      currUrl.value = `cluster/compliance/vetted?u=${store.state.user.id}&s=${val}`;
      // set current Hook
      currHook.value = "&";
      // get items from function
      getItemsFromApi(currUrl.value);
    };

    // change state
    const handleState = (val) => {

// clear all
handleClear();

// set
currState.value = val;
scrollToPageTop();

// restart
getPendingClaims(currState.value);

}

    // // get fresh load
    // const getPendingClaims = () => {
    //   // set current Url
    //   currUrl.value = "cluster/compliance/vetted";
    //   // set current Hook
    //   currHook.value = "?";
    //   // get items from function
    //   getItemsFromApi(currUrl.value);
    // };

    // update cluster
    const handleReset = (val) => {
      if (val != "reload") {
        response.value.data = response.value.data.map((cluster) => {
          if (cluster.id != val.clusterId) {
            return cluster;
          }

          return updateFlagCount(cluster, "compliance_flags_count", val);
        });

        if (currCluster.value?.id == val.clusterId) {
          currCluster.value = response.value.data.find((cluster) => cluster.id == val.clusterId);
        }
      } else {
        // compliance completed (reload page)
        getPendingClaims(currState.value);
        // kill currCluster
        currCluster.value = null;
      }
    };

    const updateFlagCount = (cluster, key, val) => {
      const oldCount = Number(cluster[key] || 0);
      const delta = (val.oldFlag == "y" ? -1 : 0) + (val.newFlag == "y" ? 1 : 0);

      return {
        ...cluster,
        [key]: Math.max(0, oldCount + delta),
      };
    };

    // enrollee ction
    const handleClear = () => {
      currCluster.value = null;
    };

    watch(
      () => props.resetKey,
      () => {
        handleClear();
      }
    );

    // enrollee ction
    const handleView = (val) => {
      currCluster.value = val;
      // move to the true page top after expanding
      scrollToPageTop();
    };

    // switch page
    const handlePage = (page) => {
      // start laoding
      isLoading.value = true;
      // go back up
      scrollToPageTop();
      // get new page items from function
      getItemsFromApi(`${currUrl.value}${currHook.value}page=${page}`);
    };

    const scrollToPageTop = () => {
      requestAnimationFrame(() => {
        window.scrollTo({
          top: 0,
          behavior: "smooth",
        });
      });
    };

    // output results
    const clusters = computed(() => {
      if (!response.value) {
        return [];
      } else {
        return response.value.data; // get data portion
      }
    });

    // output pages
    const allPages = computed(() => {
      if (!response.value) {
        return [];
      } else {
        return response.value; // get all
      }
    });

    const currentStateTitle = computed(() => {
      return tabsState.value.find((tab) => tab.id === currState.value)?.title || "Everything";
    });


    return {
      capWords,
      numberBadge,
      // grossTotalSent,
      // grossTotalApproved,
      toMonthYear,
      claimContext,
      checkPaid,
      handleState,
      handleReset,
      handlePage,
      handleClear,
      handleView,
      tabsState,
      currState,
      currServerDate,
      currCluster,
      currentStateTitle,
      isReady,
      isLoading,
      error,
      clusters,
      allPages,
    };
  },
};
</script>

<style scoped>
.progress {
  margin: 0;
}

.claims-loading-bar {
  border-radius: 0;
  height: 3px;
  margin: -1px 0 10px;
}

.supervisor-claims-workbench {
  color: #263238;
}

.supervisor-claims-frame {
  margin-left: 0;
  margin-right: 0;
}

.supervisor-claims-frame-col {
  padding-left: 0 !important;
  padding-right: 0 !important;
}

.premium-queue-head,
.claims-table-head,
.claim-batch-row {
  background: #ffffff;
  border: 1px solid #eeeeee;
  border-radius: 6px;
  box-shadow: none;
}

.premium-queue-head {
  align-items: flex-end;
  background: #ffffff;
  border-color: #f0f0f0;
  box-shadow: none;
  display: flex;
  gap: 22px;
  justify-content: space-between;
  overflow: visible;
  padding: 24px 26px;
  position: relative;
  z-index: 2;
}

.premium-queue-head::before {
  border: 1px solid #c4d3d9;
  border-bottom: 0;
  border-radius: 7px 7px 0 0;
  content: "";
  height: 18px;
  left: -1px;
  pointer-events: none;
  position: absolute;
  right: -1px;
  top: -1px;
  z-index: 1;
}

.premium-queue-head > * {
  position: relative;
  z-index: 2;
}

.queue-title-block h5 {
  color: #263238;
  font-weight: 700;
  margin: 4px 0 0;
}

.queue-title-block p {
  color: #607d8b;
  line-height: 1.45;
  margin: 6px 0 0;
}

.workbench-label {
  color: #607d8b;
  display: block;
  font-size: 0.75rem;
  font-weight: 700;
  margin-bottom: 6px;
  text-transform: uppercase;
}

.scheme-switch {
  background: #f7f7f7;
  border: 1px solid #eeeeee;
  border-radius: 6px;
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
  padding: 4px;
}

.scheme-switch button {
  background: transparent;
  border: none;
  border-radius: 5px;
  color: #607d8b;
  cursor: pointer;
  font-size: 0.82rem;
  font-weight: 700;
  min-height: 34px;
  padding: 0 14px;
}

.scheme-switch button.is-active {
  background: #263238;
  color: #ffffff;
}

.claims-table-head {
  background: rgba(255, 255, 255, 0.72);
  color: #607d8b;
  font-size: 0.78rem;
  font-weight: 700;
  margin-bottom: 12px;
  padding: 13px 20px;
  text-transform: uppercase;
}

.claim-batch-row {
  background: linear-gradient(180deg, #ffffff 0%, #fdfdfd 100%);
  margin-bottom: 12px;
  padding: 24px 22px;
}

.claim-batch-row .row {
  align-items: center;
  display: flex;
  flex-wrap: wrap;
}

.claim-batch-row.is-open {
  border-color: #80cbc4;
  box-shadow: 0 8px 22px rgba(38, 50, 56, 0.08);
  margin-bottom: 0;
}

.row-index {
  color: #607d8b;
  font-weight: 700;
  margin: 0;
}

.provider-cell {
  color: #263238;
  font-size: 1.02rem;
  font-weight: 700;
  line-height: 1.35;
  margin: 0;
}

.provider-cell small,
.period-cell small {
  color: #607d8b;
  font-size: 0.78rem;
  font-weight: 600;
}

.claim-context-badge {
  border-radius: 999px;
  display: inline-flex;
  font-size: 0.68rem;
  font-weight: 800;
  line-height: 1;
  margin-left: 6px;
  padding: 5px 7px;
  text-transform: uppercase;
  vertical-align: middle;
}

.claim-context-badge.is-supplementary {
  background: #e8f5e9;
  color: #2e7d32;
}

.claim-context-badge.is-reconciliation {
  background: #fff3e0;
  color: #ef6c00;
}

.claim-batch-row .chip {
  border-radius: 6px;
  font-size: 0.85rem;
  font-weight: 700;
  margin: 0;
  min-width: 132px;
  padding: 0 12px;
  text-align: center;
}

.period-cell {
  color: #263238;
  font-weight: 700;
  line-height: 1.35;
  margin: 0;
}

.agent-cell {
  background: #eceff1;
  border-radius: 6px;
  color: #455a64;
  display: inline-block;
  font-size: 0.82rem;
  line-height: 1.2;
  margin: 0;
  padding: 7px 9px;
}

.row-action {
  align-items: center;
  background: #00838f;
  border: none;
  border-radius: 6px;
  color: #ffffff;
  cursor: pointer;
  display: inline-flex;
  height: 36px;
  justify-content: center;
  padding: 0;
  width: 36px;
}

.row-action.is-close {
  background: #263238;
}

.row-action i {
  font-size: 20px;
}

.empty-review-state {
  align-items: center;
  background: #ffffff;
  border: 1px solid #eeeeee;
  border-radius: 6px;
  color: #607d8b;
  display: flex;
  flex-direction: column;
  margin-top: 12px;
  padding: 36px 24px;
  text-align: center;
}

.empty-review-icon {
  align-items: center;
  background: #eef6f5;
  border: 1px solid #dcebe8;
  border-radius: 6px;
  color: #00897b;
  display: inline-flex;
  height: 44px;
  justify-content: center;
  margin-bottom: 14px;
  width: 44px;
}

.empty-review-icon i {
  font-size: 23px;
}

.empty-review-state h6 {
  color: #263238;
  font-size: 1rem;
  font-weight: 700;
  margin: 0;
}

.empty-review-state p {
  font-size: 0.88rem;
  font-weight: 500;
  line-height: 1.45;
  margin: 6px 0 0;
}

.spacer10 {
  margin-top: 10px;
  margin-bottom: 10px;
}

.pointer {
  cursor: default;
}

.edit-item:hover .material-icons.grey-text,
.edit-item:hover .material-icons.grey-text::before {
  color: rgb(21, 21, 206) !important;
}

.chip-more {
  cursor: pointer;
  background-color: #eaecee !important;
}

.chip-more:hover {
  color: white !important;
  background-color: black !important;
}

.chip-less {
  cursor: pointer;
  color: white !important;
  background-color: black !important;
}

.chip-less:hover {
  color: black !important;
  background-color: #eaecee !important;
}

@media only screen and (min-width: 601px) and (max-width: 992px) {
  .premium-queue-head {
    align-items: flex-start;
    flex-direction: column;
    gap: 16px;
    padding: 22px;
  }

  .scheme-switch {
    flex-wrap: nowrap;
    overflow-x: auto;
    width: 100%;
  }

  .scheme-switch button {
    flex: 0 0 auto;
    min-width: 118px;
  }

  .claims-table-head {
    display: none;
  }

  .claim-batch-row {
    padding: 18px 20px;
  }

  .claim-batch-row .row {
    display: grid;
    gap: 12px 16px;
    grid-template-columns: 40px minmax(0, 1fr) minmax(0, 1fr) 44px;
  }

  .claim-batch-row .col {
    margin: 0;
    padding: 0;
    width: 100% !important;
  }

  .claim-batch-row .row > .col:nth-child(1) {
    grid-column: 1;
    grid-row: 1;
  }

  .claim-batch-row .row > .col:nth-child(2) {
    grid-column: 2 / 4;
    grid-row: 1;
  }

  .claim-batch-row .row > .col:nth-child(3) {
    grid-column: 2;
    grid-row: 2;
  }

  .claim-batch-row .row > .col:nth-child(4) {
    grid-column: 3;
    grid-row: 2;
  }

  .claim-batch-row .row > .col:nth-child(5) {
    grid-column: 2;
    grid-row: 3;
  }

  .claim-batch-row .row > .col:nth-child(6) {
    grid-column: 3;
    grid-row: 3;
  }

  .claim-batch-row .row > .col:nth-child(7) {
    align-self: center;
    grid-column: 4;
    grid-row: 1 / 4;
    justify-self: end;
  }

  .claim-batch-row .col p {
    margin: 0;
  }

  .claim-batch-row .chip,
  .period-cell,
  .agent-cell {
    width: 100%;
  }

  .row-action {
    height: 40px;
    width: 40px;
  }

  .claim-batch-row.is-open .row > .col:nth-child(7) {
    grid-column: 1 / -1;
    grid-row: auto;
    justify-self: stretch;
  }

  .claim-batch-row.is-open .row > .col:nth-child(7) > .right {
    display: block;
    float: none !important;
    width: 100%;
  }

  .claim-batch-row.is-open .row-action.is-close {
    float: none !important;
    width: 100%;
  }

}

@media only screen and (min-width: 601px) and (max-width: 760px) {
  .claim-batch-row .row {
    grid-template-columns: minmax(0, 1fr) 44px;
  }

  .claim-batch-row .row > .col:nth-child(1) {
    display: none;
  }

  .claim-batch-row .row > .col:nth-child(2) {
    grid-column: 1;
    grid-row: 1;
  }

  .claim-batch-row .row > .col:nth-child(3),
  .claim-batch-row .row > .col:nth-child(4),
  .claim-batch-row .row > .col:nth-child(5),
  .claim-batch-row .row > .col:nth-child(6) {
    grid-column: 1 / -1;
    grid-row: auto;
  }

  .claim-batch-row .row > .col:nth-child(7) {
    grid-column: 2;
    grid-row: 1;
  }

  .claim-batch-row.is-open .row > .col:nth-child(7) {
    grid-column: 1 / -1;
    grid-row: auto;
  }

}

@media only screen and (max-width: 600px) {
  .premium-queue-head {
    align-items: flex-start;
    flex-direction: column;
    gap: 16px;
    padding: 20px;
  }

  .queue-title-block h5 {
    font-size: 1.35rem;
    line-height: 1.25;
  }

  .scheme-switch {
    flex-wrap: nowrap;
    overflow-x: auto;
    width: 100%;
  }

  .scheme-switch button {
    flex: 0 0 auto;
    min-width: 118px;
  }

  .claims-table-head {
    display: none;
  }

  .claim-batch-row {
    margin-bottom: 10px;
    padding: 22px 20px;
  }

  .claim-batch-row .row {
    align-items: stretch;
    display: grid;
    gap: 12px;
    grid-template-columns: minmax(0, 1fr);
  }

  .claim-batch-row .col {
    margin: 0;
    padding: 0;
    width: 100% !important;
  }

  .claim-batch-row .col.s12,
  .claim-batch-row .col.s4,
  .claim-batch-row .col.s6 {
    grid-column: 1 / -1;
  }

  .claim-batch-row .col p {
    margin: 0;
  }

  .provider-cell {
    font-size: 1rem;
  }

  .claim-batch-row .chip,
  .agent-cell,
  .period-cell {
    box-sizing: border-box;
    display: block;
    padding-left: 16px;
    padding-right: 16px;
    text-align: left;
    width: 100%;
  }

  .period-cell {
    padding-left: 0;
    padding-right: 0;
  }

  .row-action {
    height: 42px;
    width: 100%;
  }

  .claim-batch-row.is-open .row > .col:nth-child(7) > .right {
    display: block;
    float: none !important;
    width: 100%;
  }

  .claim-batch-row.is-open .row-action.is-close {
    float: none !important;
    width: 100%;
  }
}
</style>
